"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DqBackdrop = ({
  className = "",
  invisible = false,
  onClick,
  children
}) => /*#__PURE__*/_react.default.createElement("div", {
  role: "presentation",
  className: (0, _classnames.default)("dq-fixed dq-inset-0 dq-z-50", {
    "dq-bg-gray-800 dq-bg-opacity-80": !invisible
  }, className),
  onClick: onClick
}, children);

DqBackdrop.defaultProps = {
  className: "",
  invisible: false,
  onClick: () => {}
};
var _default = DqBackdrop;
exports.default = _default;